import { useCallback, useEffect, useRef } from 'react';

type Callback<T = unknown> = (...args: T[]) => void;
export function useDebounce<T>(callback: Callback<T>, wait = 150): [Callback<T>, () => void] {
  const cb = useRef<Callback<T> | undefined>(undefined);
  useEffect(() => {
    cb.current = callback;
  }, [callback]);
  const timeout = useRef<number | undefined>(undefined);

  const cancelDebounce = useCallback(() => {
    clearTimeout(timeout.current);
    timeout.current = undefined;
  }, []);
  const debounce = useCallback(
    (...args: T[]) => {
      const handler = () => cb.current && cb.current(...args);
      clearTimeout(timeout.current);
      timeout.current = window.setTimeout(handler, wait);
    },
    [wait]
  );

  return [debounce, cancelDebounce];
}
